import { type PayloadAction , createSlice } from '@reduxjs/toolkit';
import { type MappingAuditState, ScreenMode, Tab} from '../../common/domain/mappingAudit';

const initialState: MappingAuditState = {
  screenMode: ScreenMode.VIEWING_MODE,
  loadedTabs: [],
  selectedRows: { [Tab.RATES_FIELD]: {}, [Tab.RATES_FIXING]: {}, [Tab.LEGAL_ENTITY]: {} },
  loading: false,
  activeTab: Tab.RATES_FIELD,
  errorMessage: null,
  successMessage: null,
};

export const slice = createSlice({
  name: 'mappingAudit',
  initialState,
  reducers: {
    setScreenMode(state, action: PayloadAction<ScreenMode>) {
      state.screenMode = action.payload;
    },
    setActiveTab(state, action: PayloadAction<Tab>) {
      state.activeTab = action.payload;
    },
  },
});

export const { setScreenMode, setActiveTab } = slice.actions;
export default slice.reducer;


